export default async function scrollToTop(
  duration: number = 400
): Promise<void> {
  const initialScrollOffset = window.scrollY || window.pageYOffset;
  let lastTimestamp = performance.now();

  let aborted = false;
  let lastScrollY: number;
  function abandonOnScrollDown(event: WheelEvent | UIEvent) {
    if ((event as WheelEvent).deltaY && (event as WheelEvent).deltaY > 0) {
      aborted = true;
      return;
    }

    if (lastScrollY && window.scrollY > lastScrollY) {
      aborted = true;
    }

    lastScrollY = window.scrollY;
  }
  document.addEventListener('wheel', abandonOnScrollDown);
  document.addEventListener('scroll', abandonOnScrollDown);

  return new Promise<void>(resolve => {
    const performScrollStep: FrameRequestCallback = (time: number) => {
      const yOffset = window.scrollY || window.pageYOffset;

      if (aborted || yOffset === 0) {
        document.removeEventListener('wheel', abandonOnScrollDown);

        resolve();
        return;
      }

      const timeSinceLastUpdate = time - lastTimestamp;
      lastTimestamp = time;

      const fractionOfTotalScrollDuration = timeSinceLastUpdate / duration;
      const distanceToScroll =
        initialScrollOffset * fractionOfTotalScrollDuration;

      window.scrollBy(0, -distanceToScroll);
      requestAnimationFrame(performScrollStep);
    };

    requestAnimationFrame(performScrollStep);
  });
}



// WEBPACK FOOTER //
// ./src/app/utils/scrollToTop.ts